// extracted by mini-css-extract-plugin
export default {"pageContainer":"layout_pageContainer__vdZiC"};